import type {FC} from 'react';

import type {Props} from './types';

import * as S from './styles';

export const ModalFooter: FC<Props> = ({
  footerContainerId,
  modalPadding,
  renderFooter,
}) => {
  return (
    <S.Container id={footerContainerId} modalPadding={modalPadding}>
      {renderFooter ? renderFooter() : null}
    </S.Container>
  );
};
